import { useSelector } from "react-redux";
import TextField from "../../../../../components/input-fields/TextField";
import Tooltip from "../../../../../components/Tooltip";
import DurationDropdown from "./accordion-body-components/DurationDropdown";

const AppointmentTypesAccordionBody = ({ item, index, onAppointmentTypeUpdated }) => {
  const { config } = useSelector((state) => state.calendarManagement);
  const { appointmentTypeErrors } = useSelector((state) => state.calendarManagement);
  const agentLanguage = useSelector((state) => state.info.agentLanguage);
  const voices = useSelector((state) => state.info.voices);
  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const selectedVoice = voices?.find((voice) => voice.id === updatedVoice);
  const selectedLanguage = selectedVoice?.language || agentLanguage || "en-US";
  const regexByLanguage = {
    "en-US": { inputRegex: /^[a-zA-Z\s]*$/, regexMessage: "Only characters and spaces are allowed" },
    "he-IL": {
      inputRegex: /^[a-zA-Zא-ת\s]*$/,
      regexMessage: "Only Hebrew and English characters and spaces are allowed",
    },
  };

  const onAppointmentTypeUpdatedInternal = (key, value) => {
    onAppointmentTypeUpdated(index, key, value);
  };

  return (
    <div
      className={`flex flex-col ${
        appointmentTypeErrors[index]?.type ? "gap-6 md:gap-4" : "gap-6"
      } w-full py-2 items-start`}
    >
      <div
        className={`w-full flex flex-col md:flex-row justify-between ${
          appointmentTypeErrors[index]?.type ? "gap-6" : "gap-4"
        } md:gap-0`}
      >
        <div className="w-full md:w-[68%]">
          <TextField
            title={"Appointment name"}
            value={item.type}
            placeholder={"Appointment name"}
            onChange={(value) => onAppointmentTypeUpdatedInternal("type", value)}
            lines={2}
            baseLine={1}
            required={config.minAppointmentTypeCharacters > 0}
            maxCharacters={config.maxAppointmentTypeCharacters}
            errorMessage={appointmentTypeErrors[index]?.type}
            regexMessage={regexByLanguage[selectedLanguage]?.regexMessage}
            inputRegex={regexByLanguage[selectedLanguage].inputRegex}
          />
        </div>
        <div className="w-full md:w-[30%]">
          <DurationDropdown
            contactIndex={index}
            duration={item.duration}
            onChange={(value) => onAppointmentTypeUpdated(index, "duration", value)}
            errorMessage={appointmentTypeErrors[index]?.duration}
          />
        </div>
      </div>
      <div className="w-full flex items-center gap-4">
        <TextField
          title={"Description"}
          value={item.description}
          placeholder={"Description"}
          onChange={(value) => onAppointmentTypeUpdatedInternal("description", value)}
          lines={2}
          baseLine={1}
          required={config.minAppointmentDescriptionCharacters > 0}
          maxCharacters={config.maxAppointmentDescriptionCharacters}
          errorMessage={appointmentTypeErrors[index]?.description}
        />
        <Tooltip text="The description will be read to callers when scheduling an appointment. Try to keep it clear and concise." />
      </div>
      <div className="w-full flex items-center gap-4">
        <TextField
          title={"Confirmation text message"}
          value={item.postSchedulingTextMessage ?? ""}
          placeholder={"Confirmation text message"}
          onChange={(value) => onAppointmentTypeUpdatedInternal("postSchedulingTextMessage", value)}
          lines={2}
          baseLine={1}
          required={config.minAppointmentPostSchedulingTextMessageCharacters > 0}
          maxCharacters={config.maxAppointmentPostSchedulingTextMessageCharacters}
          errorMessage={appointmentTypeErrors[index]?.postSchedulingTextMessage}
        />
        <Tooltip text="Add a personalized text message to complement the appointment details sent upon successful scheduling. Use it to share directions, remote meeting links, pre-appointment instructions, or other information relevant to this appointment." />
      </div>
    </div>
  );
};

export default AppointmentTypesAccordionBody;
